
import { useState } from "react";
import { getVehicleDeliveryCancelFn } from "../../../transactions/deliveryBooking/deliveryBooking";
import { validateResponse } from "../deliveryUtils";
import { toast } from "../../../components/ui/Toast/useToast";
import { TrashIcon } from "../../../icons";
import { queryClient } from "../../../utils/queryClient";
import { QUERY_KEYS } from "../../../config/constants";
import { ConfirmationDialog, CustomModal } from "../../../components/ui";

export const BookingCancelButton = ({ flowId, carPlate, isRetail = false, appointment={} }) => {
  // LOCAL STATE:
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [isCancelLoading, setIsCancelLoading] = useState(false);

  const { VEHICLE_DELIVERY_INFO } = QUERY_KEYS;
  
    const cancelText = () => {
    return appointment?.HasHomeDelivery ? "Θέλεις σίγουρα να ακυρώσεις το ραντεβού; Για να το προγραμματίσεις εκ νέου, επικοινώνησε άμεσα με το Τμήμα Παράδοσης Αυτοκινήτων μέσω e-mail στο car-delivery@avis.gr." : `Θέλεις να ακυρώσεις το ραντεβού παραλαβής για την 
      ${new Date(appointment?.ScheduledDate).toLocaleDateString('el-GR', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          timeZone: 'UTC',
        })};`
  }

  // DATA:
  // const { carInfo } = useServiceCarStore();

  // LOCAL VARIABLES:

    const handleCancelAppointment = async () => {
    try {
      setIsCancelLoading(true)
      const response = await getVehicleDeliveryCancelFn({vehicleFlowId:flowId, payload:{}});
      if (validateResponse(response)) {
       toast({
          variant: 'success',
          description: `Το ραντεβού ακυρώθηκε.${appointment?.HasHomeDelivery ? ' Για νέο προγραμματισμό, επικοινώνησε στο car-delivery@avis.gr.' : ""}`,
        });
        setOpenCancelModal(false)
        setIsCancelLoading(false)
        queryClient.invalidateQueries({
            queryKey: [VEHICLE_DELIVERY_INFO, carPlate],
        });
      }
    } catch (e) {
      console.warn('Undo failed', e);
    } finally {
      setOpenCancelModal(false)
      setIsCancelLoading(false)
    }
  }


  return (
    <>
      {<CustomModal
        triggerComponent={isRetail ? <TrashIcon width={24} height={24} /> :
          <p className="text-sm font-semibold text-[#D4002A] cursor-pointer">Ακύρωση ραντεβού</p>
        }
        openModal={openCancelModal}
        handleClick={(value) => {setOpenCancelModal(value)}}
      >
        <div className="container-sm mx-auto py-10">
          <ConfirmationDialog
            message={cancelText()}
            title="Ακύρωση προγραμματισμένου ραντεβού"
            isLoading = {isCancelLoading}
            
            handleOkClick={()=>handleCancelAppointment()}
            handleCancelClick={() => setOpenCancelModal(false)}
            confirmCtaText="Ακύρωση"
            cancelCtaText="Επιστροφή"
          />
        </div>
      </CustomModal>}
    </>
  );
};
